module.exports = __webpack_public_path__ + "static/media/jan.332eb5bb.jpg";